// Centralized external links for Liz DiRocco site
export const LINKS = {
  calendly: "https://calendly.com/lizdirocco/cash-conversation",
  linkedin: "https://www.linkedin.com/in/lizdirocco",
  youtube: "https://www.youtube.com/@lizdirocco",
  instagram: "https://www.instagram.com/lizdirocco",
  email: "mailto:liz@lizdirocco.com",
  guidePdf: "https://canva.link/v22ugturc7sie2q",
};

// Brand assets — uploaded by Liz (full resolution)
export const BRAND = {
  monogramOnDark:
    "https://customer-assets.emergentagent.com/job_banking-systems-1/artifacts/ywq9xyr4_ChatGPT%20Image%20Jun%2012%2C%202026%2C%2005_19_19%20PM.png",
};

export const PHOTOS = {
  // Newer professional portraits — primary for founder imagery
  lizOutdoor:
    "https://customer-assets.emergentagent.com/job_banking-systems-1/artifacts/y2efoot6_ChatGPT%20Image%20Jun%2012%2C%202026%2C%2004_55_55%20PM.png",
  lizIndoor:
    "https://customer-assets.emergentagent.com/job_banking-systems-1/artifacts/vmg1rcq5_ChatGPT%20Image%20Jun%2011%2C%202026%2C%2002_16_03%20PM.png",
  // Legacy personal photo — preserved
  lizAbout:
    "https://customer-assets.emergentagent.com/job_banking-systems-1/artifacts/co1xfgut_IMG_6455.jpg",
  credibility: {
    stage:
      "https://customer-assets.emergentagent.com/job_banking-systems-1/artifacts/3ix18zsy_11507601-9C2E-4A45-A201-3F732F1571B7.JPEG",
    conversation:
      "https://customer-assets.emergentagent.com/job_banking-systems-1/artifacts/k1bv5flc_C468308B-0A37-4484-AA3C-B91BB00DADA1.JPEG",
    book: "https://customer-assets.emergentagent.com/job_banking-systems-1/artifacts/qyvfzn0a_52886527-C0A3-4E5A-97FE-9261D14735FB.jpg",
  },
  // Brand-board cinematic hero — Mediterranean villa with olive tree & lounger
  heroVilla:
    "https://customer-assets.emergentagent.com/job_banking-systems-1/artifacts/6vukj8zn_ChatGPT%20Image%20Jun%2012%2C%202026%2C%2005_19_06%20PM.png",
  heroVillaFallback:
    "https://images.unsplash.com/photo-1571896349842-33c89424de2d?auto=format&fit=crop&w=2400&q=85",
};
